import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class HomeCareAuthService {
    private apiUrl = environment.homeCareApiUrl;

    private auth = new BehaviorSubject<boolean>(false);
    public authState = this.auth.asObservable();

    // Current user subject
    private currentHomeCareSubject = new BehaviorSubject<any>(null);
    public currentHomeCare = this.currentHomeCareSubject.asObservable();

    constructor(private http: HttpClient) {
        const token = this.getToken();
        if (token) {
            this.auth.next(true);
            const user = this.getUserDetails();
            if (user) {
                this.currentHomeCareSubject.next(user);
            }
        }
    }

    updateUser(authState: boolean, user: any): void {
        this.auth.next(authState);
        this.currentHomeCareSubject.next({ ...user });
    }

    login(credentials: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/login`, credentials);
    }

    sendOTP(mobileObj: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/send-otp`, mobileObj);
    }

    resetOTP(mobileObj: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/verify/resend/facility`, mobileObj);
    }

    getProfile(): Observable<any> {
        return this.http.get(`${this.apiUrl}/vendors/profile`);
    }

    verifyOTP(otpObj: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/login-otp`, otpObj);
    }


    changePassword(pwdObj: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/change-password`, pwdObj);
    }

    setPassword(pwdObj: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/set-password`, pwdObj);
    }

    logout(): Observable<any> {
        return this.http.post(`${this.apiUrl}/vendors/logout`, {});
    }

    setUserDetails(user: any): void {
        localStorage.setItem('homecare', JSON.stringify(user));
        if (user) {
            this.updateUser(true, user);
        } else {
            this.updateUser(false, null);
        }
    }

    setToken(token: string): void {
        localStorage.setItem('homeCareToken', token);
    }

    getToken(): string | null {
        return localStorage.getItem('homeCareToken');
    }

    removeTokens(): void {
        localStorage.removeItem('homeCareToken');
        localStorage.removeItem('homecare');
    }

    getUserDetails(): any {
        const user = localStorage.getItem('homecare');
        return user ? JSON.parse(user) : null;
    }

    isLoggedIn(): boolean {
        return !!this.getToken();
    }
}